module.exports = __webpack_public_path__ + "static/media/whyOne.411cda02.png";